import { render, staticRenderFns } from "./Cartoes.vue?vue&type=template&id=6f5b66c2"
import script from "./Cartoes.vue?vue&type=script&lang=js"
export * from "./Cartoes.vue?vue&type=script&lang=js"
import style0 from "./Cartoes.vue?vue&type=style&index=0&id=6f5b66c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports